export interface UserContextRoleProfilePermissionFieldDTO {
    fieldName?: string;
    fieldType?: string;
    fieldMapping?: string;
    permissionCd?: string;
}
